module.exports.thangNames = thangNames =
  'Ogre Munchkin F': [
    # Female
    'Alali'
    'Anabel'
    'Babaga'
    'Delma'
    'Dosha'
    'Gurzunn'
    'Hoot'
    'Inski'
    'Iyert'
    'Lacos'
    'Merna'
    'Palt'
    'Paulark'
    'Pripp'
    'Shmeal'
    'Upfish'
    'Yugark'
    'Shema'
  ]
  'Ogre Munchkin M': [
    # Male
    'Blob'
    'Brack'
    'Cragg'
    'Dobo'
    'Draff'
    'Eugen'
    'Gert'
    'Godel'
    'Goreball'
    'Gordok'
    'Gorylo'
    'Gort'
    'Kog'
    'Kogpole'
    'Kratt'
    'Leerer'
    'Nerph'
    'Oogre'
    'Raack'
    'Ragtime'
    'Raort'
    'Rexxar'
    'Skoggen'
    'Smerk'
    'Snortt'
    'Thabt'
    'Toremon'
    'Treg'
    'Ursa'
    'Vorobun'
    'Weeb'
    'Yart'
    'Zozo'
    'Zock'
  ]
  'Ogre Thrower': [
    # Female
    'Beebatha'
    'Dross'
    'Drumbaa'
    'Durnath'
    'Esha'
    'Gragthar'
    'Grel'
    'Hamedi'
    'Jinjin'
    'Kraggan'
    'Kyrgg'
    'Makas'
    'Moza'
    'Pinakin'
    'Rakash'
    'Rasha'
    'Savatha'
    'Vujii'
    'Wuda'
    'Yetu'
    'Zara'
  ]
  'Griffin Rider': [
    # Female
    'Aeoldan'
    'Bestarius'
    'Cristofide'
    'Denestorath'
    'Letholdus'
    'Loretha'
  ]
  'Paladin': [
    # Female
    'Illumina'
    'Celadia'
    'Taric'
    'Vaelia'
    'Antary'
    'Femae'
  ]
  'Ogre Witch': [
    # Female
    'Vyrryx'
    'Yzzrith'
    'Xith'
  ]
  'Ogre Chieftain': [
    # Female
    'Zagra Ux'
    'Oniko'
  ]
  'Ogre Warlock': [
    # Male
    'Gronak'
    'Sorgoth'
    'Vax'
    'Vyrryx'
    'Vyjj'
  ]
  'Ogre Scout M': [
    # Male
    'Frandar'
    'Karnaugh'
    'Lanthon'
    'Tarjan'
    'Yorgalfen'
  ]
  'Ogre Scout F': [
    # Female
    'Freesa'
    'Ganju'
    'Hopper'
    'Ralthora'
    'Yugorota'
  ]
  'Burl': [
    # Animal
    'Borlit'
    'Burlosh'
    'Dorf'
    'Teemer'
  ]
  'Sand Yak': [
    # Animal
    'Arngotho'
    'Falthror'
    'Girvan'
    'Langthok'
    'Ofgar'
    'Randall'
  ]
  # Pets only have one name
  'Raven Pet': ['Nevermore']
  'Cougar Pet': ['Kitty']
  'Frog Pet': ['Hypnotoad']
  'Baby Griffin Pet': ['Griffin']
  'Pugicorn Pet': ['Peggy']
  'Polar Bear Pet': ['Klondike']
  'Wolf Pup Pet': ['Wolf']
  'Horse': [
    # Animal
    'Abby'
    'Beauty'
    'Cinnamon'
    'Codasus'
    'Ed'
    'Fleetfire'
    'Hurricane'
    'Lovelace'
    'Miracle'
    'Mirial'
    'Powder'
    'Silver'
    'Wildsilver'
  ]
  'Ogre M': [
    # Male
    'Axe Ox'
    'Belch'
    'Booz'
    'Brusentsov'
    'Demonik'
    'Dronck'
    'Gorlog'
    'Grumus'
    'Gug'
    'Gurulax'
    'Krogg'
    'Kulgor'
    'Mak Fod'
    'Mokrul'
    'Muthyala'
    'Oni'
    'Polifemo'
    'Saltporker'
    'Skrungt'
    'Steve'
    'Stinker'
    'Tarlok'
    'Trogdor'
    'Trung'
    'Vargutt'
    'Vyle'
  ]
  'Ogre F': [
    # Female
    'Alkaz'
    'Gar\'ah'
    'Glonc'
    'Holkam'
    'Kriskull'
    'Mak\'rah'
    'Marghurk'
    'Marnag'
    'Martha'
    'Morthrug'
    'Nareng'
    'Maleda'
  ]
  'Ogre Brawler': [
    # Male
    'Arelt'
    'Borgag'
    'Boz'
    'Burobb'
    'Dijkstro'
    'Grognar'
    'Grul\'thock'
    'Grumoll'
    'Haggar'
    'Heizenburg'
    'Ironjaw'
    'Mokuhr'
    'Muul'
    'Ork\'han'
    'Roast Beefy'
    'Toharg'
    'Trod'
    'Tuguro'
    'Turrok'
    'York'
    'Zabarek'
    'Zagurk'
    'Zeredd'
  ]
  'Ogre Fangrider': [
    # Female
    'Arizard'
    'Bortrok'
    'Boruvka'
    'Doralt'
    'Dreek'
    'Flarsho'
    'Geggret'
    'Gurzthrot'
    'Mizzy'
    'Morzgret'
    'Murgark'
    'Muttin'
    'Secka'
  ]
  'Ogre Shaman': [
    # Female
    'Ahst\'durante'
    'Aolian\'Tak'
    'Drun'
    'Ghuk'
    'Gogg'
    'Gom'
    'Grek'
    'Gror'
    'Grue'
    'Il\'Du\'duka'
    'Makas'
    'Mogadishu'
    'Nazgareth'
    'Poult'
    'Sham\'uk'
    'Torluk'
    'Turann'
    'Tuzang'
    'Tuzell'
    'Ugoki'
    'Uld\'Mak'
    'Varreth'
    'Yamizeb'
    'Yerong'
    'Yugargen'
    'Zo\'Goroth'
    'Zulabar'
  ]
  'Skeleton': [
    # Both
    'Bloody Johnny'
    'Bone Daddy'
    'Bonejangles'
    'Bonesworth'
    'Bonette'
    'Boneus'
    'Doornail'
    'Drybones'
    'Grim'
    'Haskell'
    'Indiana Bones'
    'James Bone'
    'Kate'
    'Palatine'
    'Ribster'
    'Rusty'
    'Sacra'
    'Scraps'
    'Shelly'
    'Shishka-Bob'
    'Shishka-Joe'
    'Shishka-Larry'
    'Skeletor'
    'Skellington'
    'Skulldugger'
    'Skully'
    'Smitty'
    'Sphenoid'
    'Sternum'
    'Talus'
    'Tatava'
    'Ulna'
    'Yorick'
  ]
  'Ogre Headhunter': [
    # Male
    'Bob'
    'Deadtooth'
    'Ez the Cruel'
    'Grroq'
    'Mog'
    'Mogvar'
    'Ral\'thuk'
    'Soth'
    'Ulxx'
    'Ur'
    'Veznyr'
    'Warlegs'
    'Xul Gor'
  ]
  'Trapper': [
    # Male
    'Senick'
    'John'
    'Kyle'
  ]
  'Forest Archer': [
    # Female
    'Naria'
    'Sylva'
    'Archia'
  ]
  'Raider': [
    # Female
    'Arryn'
    'Thrat'
  ]
  'Goliath': [
    # Male
    'Okar'
    'Ivan'
  ]
  'Guardian': [
    # Female
    'Illia'
    'Gaia'
  ]
  'Pixie': [
    # Female
    'Zana'
    'Eika'
  ]
  'Assassin': [
    # Male
    'Blackjack'
    'Kha\'Zix'
    'Ritic'
    'Rengar'
    'Shade'
    'Talon'
    'Zed'
    'Sherkey'
  ]
  'Necromancer': [
    # Male
    'Krekai'
    'Kethum'
    'Morcelu'
    'Nalfar'
    'Drezhul'
  ]
  'Master Wizard': [
    # Female
    'Lilith'
    'Kuhafas'
    'Usara'
    'Veigar'
    'Voldemort'
    'Vallyria'
  ]
  'Archer F': [
    # Female
    'Agapi'
    'Alden'
    'Alleria'
    'Atalanta'
    'Artemis'
    'Beatrice'
    'Bachi'
    'Beverly'
    'Cairn'
    'Cecily'
    'Clare'
    'Erica'
    'Gemma'
    'Ivy'
    'Jensen'
    'Katniss'
    'Katreena'
    'Keturah'
    'Kim'
    'Korra'
    'Lina'
    'Luna'
    'Mercedes'
    'Mira'
    'Mirana'
    'Natalie'
    'Odette'
    'Omar'
    'Orly'
    'Phoebe'
    'Prim'
    'Rosaline'
    'Rowan'
    'Tansy'
    'Tauriel'
    'Vereesa'
    'Vesper'
    'Yilitha'
  ]
  'Archer M': [
    # Male
    'Arty'
    'Brian'
    'Cole'
    'Denin'
    'Dev'
    'Fidsdale'
    'Gimsley'
    'Hunter'
    'Kikariy'
    'Legolas'
    'Loco'
    'Logos'
    'Lycan'
    'Mars'
    'Odysseos'
    'Oliver'
    'Quinn'
    'Robin'
    'Roman'
    'Simon'
    'Slyvos'
    'Vican'
    'Warshall'
    'Yue Fei'
    'Zhou Tong'
    'Archy'
  ]
  'Peasant M': [
    # Male
    'Azgot'
    'Brom'
    'Blemmin'
    'Carlton'
    'Charles'
    'Durfkor'
    'Duan'
    'Fendrel'
    'Gawain'
    'Hamming'
    'Hector'
    'Hershell'
    'Hingle'
    'Hodor'
    'Jackson'
    'James'
    'Lyle'
    'Merek'
    'Paps'
    'Piers'
    'Shimron'
    'Thad'
    'Tybalt'
    'Victor'
    'Winkler'
    'Yorik'
    'Yusef'
    'Yoltovic'
  ]
  'Peasant F': [
    # Female
    'Alexia'
    'Alianor'
    'Anastas'
    'Bernadette'
    'Brandy'
    'Cristiana'
    'Ellyn'
    'Giselle'
    'Gwendolin'
    'Helena'
    'Hilda'
    'Icey'
    'Katelyn'
    'Mary'
    'Matilda'
    'Mertia'
    'Millicent'
    'Regan'
    'Rose'
    'Ruth'
    'Tabitha'
    'Thea'
    'Lea'
  ]
  'Soldier M': [
    # Male
    'Aaron'
    'Adam'
    'Addison'
    'Alan'
    'Albert'
    'Alistair'
    'Andrew'
    'Anthony'
    'Antonio'
    'Arthur'
    'Augustus'
    'Barron'
    'Benjamin'
    'Bill'
    'Billy'
    'Bobby'
    'Bond'
    'Brandon'
    'Brian'
    'Bruce'
    'Carl'
    'Carlos'
    'Cecil'
    'Charles'
    'Chris'
    'Christopher'
    'Cid'
    'Clarence'
    'Craig'
    'Daniel'
    'Darius'
    'David'
    'Dax'
    'Dennis'
    'Donald'
    'Douglas'
    'Duke'
    'Earl'
    'Edward'
    'Edwin'
    'Eric'
    'Ernest'
    'Eugene'
    'Ezra'
    'Felix'
    'Ferb'
    'Frank'
    'Fred'
    'Gary'
    'Gatsby'
    'George'
    'Gerald'
    'Gordon'
    'Gregory'
    'Guan Yu'
    'Halle'
    'Harold'
    'Harry'
    'Henry'
    'Hirium'
    'Howard'
    'Huburt'
    'Hugo'
    'Ieyasu'
    'Jack'
    'Jackson'
    'James'
    'Jason'
    'Jax'
    'Jeffrey'
    'Jeremy'
    'Jerry'
    'Jesse'
    'Jimmy'
    'Joe'
    'John'
    'Johnny'
    'Jonah'
    'Jonathan'
    'Jose'
    'Joseph'
    'Joshua'
    'Juan'
    'Jun Fan'
    'Justin'
    'Keith'
    'Kenneth'
    'Kevin'
    'Kirin'
    'Kumar'
    'Larry'
    'Lawrence'
    'Leopold'
    'Louis'
    'Lucas'
    'Lucian'
    'Malcolm'
    'Marcus'
    'Mark'
    'Martin'
    'Matthew'
    'Max'
    'Maxwell'
    'Michael'
    'Miles'
    'Mischa'
    'Musashi'
    'Nicholas'
    'Nick'
    'Noah'
    'Orion'
    'Parker'
    'Patrick'
    'Paul'
    'Peter'
    'Philip'
    'Philippian'
    'Phillip'
    'Phineas'
    'Pierce'
    'Ralph'
    'Randy'
    'Raymond'
    'Remy'
    'Rex'
    'Ricardo'
    'Richard'
    'Robert'
    'Roderick'
    'Roger'
    'Ronald'
    'Ronan'
    'Roy'
    'Russell'
    'Ryan'
    'Sage'
    'Samson'
    'Samuel'
    'Scott'
    'Sean'
    'Shawn'
    'Silas'
    'Stephen'
    'Sterling'
    'Steve'
    'Steven'
    'Stormy'
    'Tadakatsu'
    'Terry'
    'Thelonious'
    'Theo'
    'Thomas'
    'Timothy'
    'Todd'
    'Tryndamere'
    'Tyrone'
    'Victor'
    'Walter'
    'Wayne'
    'William'
    'Willie'
    'Zachary'
  ]
  'Soldier F': [
    # Female
    'Ahri'
    'Alana'
    'Alexandra'
    'Alice'
    'Allankrita'
    'Amanda'
    'Amy'
    'Andrea'
    'Angela'
    'Ann'
    'Anna'
    'Anne'
    'Annie'
    'Ann-Maria'
    'Aphrodite'
    'Ashley'
    'Barbara'
    'Betty'
    'Beverly'
    'Bonnie'
    'Brenda'
    'Buffy'
    'Carol'
    'Carolyn'
    'Catherine'
    'Cheryl'
    'Christina'
    'Christine'
    'Coco'
    'Cynthia'
    'Deborah'
    'Debra'
    'Denise'
    'Diana'
    'Diane'
    'Donna'
    'Doris'
    'Dorothy'
    'Elizabeth'
    'Emma'
    'Emily'
    'Evelyn'
    'Fiora'
    'Frances'
    'Gabrielle'
    'Gloria'
    'Gorgin'
    'Heather'
    'Helen'
    'Helga'
    'Holly'
    'Imani'
    'Irene'
    'Jacqueline'
    'Jane'
    'Janet'
    'Janice'
    'Jean'
    'Jennifer'
    'Jessica'
    'Joan'
    'Jordan'
    'Joyce'
    'Judith'
    'Judy'
    'Julia'
    'Julie'
    'Karen'
    'Katherine'
    'Kathleen'
    'Kathryn'
    'Kathy'
    'Kay'
    'Kelly'
    'Kimberly'
    'Kira'
    'Lana'
    'Laura'
    'Lillian'
    'Linda'
    'Lisa'
    'Lois'
    'Lori'
    'Louise'
    'Lukaz'
    'Margaret'
    'Maria'
    'Mariah'
    'Marie'
    'Marilyn'
    'Martha'
    'Mary'
    'Medusa'
    'Melissa'
    'Michelle'
    'Mildred'
    'Mulan'
    'Nancy'
    'Natasha'
    'Nicole'
    'Nikita'
    'Norma'
    'Pamela'
    'Patricia'
    'Paula'
    'Phyllis'
    'Rachel'
    'Rebecca'
    'Robin'
    'Ronda'
    'Rose'
    'Ruby'
    'Ruth'
    'Sana'
    'Sandra'
    'Sara'
    'Sarah'
    'Scarlett'
    'Shannon'
    'Sharon'
    'Shirley'
    'Stephanie'
    'Susan'
    'Tammy'
    'Teresa'
    'Tess'
    'Theresa'
    'Tina'
    'Trinity'
    'Virginia'
    'Wanda'
  ]
  'Ogre Peon M': [
    # Male
    'Ba Bo'
    'Bubbage'
    'Durbo'
    'Jaro'
    'Kurger'
    'Mudwich'
    'Toe Pod'
    'Zugger'
  ]
  'Ogre Peon F': [
    # Female
    'Greeke'
    'Iblet'
    'Lorba'
    'Vapa'
    'Yamra'
    'Zzoya'
  ]
  'Potion Master': [
    # Male
    'Amaranth'
    'Alchemist'
    'Arora'
    'Artephius'
    'Clause'
    'Curie'
    'Fluvius'
    'Javin'
    'Kanada'
    'Omar'
    'Paracelsus'
    'Snake'
    'Vanders'
    'Warnsdorff'
    'Zander'
  ]
  'Librarian': [
    # Female
    'Agathe'
    'Agnes'
    'Hushbaum'
    'Mariam'
    'Matilda'
    'Merilda'
    'Nordex'
    'Satish'
    'Vera'
    'Charlotte'
  ]
  'Equestrian': [
    # Male
    'Neely'
    'Reynaldo'
    'Ryder'
    'Thoron'
  ]
  'Knight': [
    # Male
    'Almeric'
    'Alphonse'
    'Altair'
    'Arthur'
    'Bertrand'
    'Bronn'
    'Bruce'
    'Drake'
    'Duran'
    'Edward'
    'Galahad'
    'Hank'
    'Hunfray'
    'Jeph'
    'Jorah'
    'Lancelot'
    'Mace'
    'Neville'
    'Shug'
    'Tharin'
    'Vint'
    'Wain'
  ]
  'Captain': [
    # Female
    'Anya'
    'Brigette'
    'Dimia'
    'Div'
    'Hardcastle'
    'Helena'
    'Isa'
    'Jan'
    'Jane'
    'Jarin'
    'Karp'
    'Katana'
    'Leona'
    'Lia'
    'Lily'
    'Nicks'
    'Philips'
    'Sarre'
    'Sun Tzu'
  ]
  'Ninja': [
    # Female
    'Akali'
    'Amara'
    'Goemon'
    'Itachi'
    'Kennen'
    'Kosaraju'
    'Madara'
    'Minato'
    'Naruto'
    'Obito'
    'Sakura'
    'Sasuke'
    'Shen'
    'Shigeru'
    'Takashi'
    'Zed'
  ]
  'Sorcerer': [
    # Female
    'Beazer'
    'Claude'
    'Gandalf'
    'Izzrts'
    'Kleene'
    'Pender'
    'Jezebel'
  ]
  'Samurai': [
    # Male
    'Hattori'
    'Hirosha'
    'Ieyasu'
    'Izotokogawa'
    'Keitaro'
    'Miyoshi'
    'Nobunaga'
    'Yasuo'
    'Yi'
  ]
  'Champion': [
    # Female
    'Ida'
    'Jasmine'
  ]
  'Duelist': [
    # Male
    'Alejandro'
  ]
  'Stalwart': [
    # Male
    'Gordon'
  ]
  'Armando Hoyos': [
    # Male
    'Armando Hoyos'
  ]
